import TopNav from './components/TopNav';
import Hero from './components/Hero';
import TopicWall from './components/TopicWall';
import DeepDiveFeed from './components/DeepDiveFeed';
import TimelineSection from './components/TimelineSection';
import LayerSection from './components/LayerSection';
import CommunitySection from './components/CommunitySection';
import SubscribeBand from './components/SubscribeBand';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 flex flex-col">
      <TopNav />
      <main className="w-full">
        <Hero />
        <TopicWall />
        <DeepDiveFeed />
        <TimelineSection />
        <LayerSection />
        <CommunitySection />
        <SubscribeBand />
      </main>
      <SiteFooter />
    </div>
  );
}